// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom-container{-webkit-user-select:none;-moz-user-select:none;user-select:none;display:flex;align-items:center;-moz-column-gap:4px;column-gap:4px}.zoom-container .zoom-label{display:inline-block;color:#a7a7a7;font-size:16px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
